<template>
  <form action="/reports/ficha-sanitaria-vegetal" method="POST" target="_blank">
    <input
      type="hidden"
      name="cpf_cnpj_produtor"
      :value="produtorEntity !== null ? produtorEntity.value : ''"
    />
    <input
      type="hidden"
      name="cod_propriedade"
      :value="propriedadeEntity !== null ? propriedadeEntity.value : ''"
    />
    <div class="row">
      <div class="col-md-5">
        <label>Produtor</label>
        <v-select
          label="label"
          :filterable="false"
          :options="produtores"
          v-model="produtorEntity"
          @input="onChangeValue"
          @search="onSearch"
          @search:focus="onFocus"
          @search:blur="onBlur"
        >
          <template slot="no-options">Pesquise produtores pelo código, nome, CPF ou CNPJ</template>
        </v-select>
      </div>
      <div class="col-md-5">
        <label>Propriedade</label>
        <v-select
          label="label"
          :loading="loadingPropriedades"
          :options="propriedades"
          v-model="propriedadeEntity"
          @search:focus="onFocus"
          @search:blur="onBlur"
        >
          <template slot="no-options">Selecine um produtor</template>
        </v-select>
      </div>
    </div>
    <div class="text text-left mt-3">
      <input
        type="submit"
        value="Gerar documento"
        :disabled="produtorEntity === null || propriedadeEntity === null"
        :class="{'ui-button': true, 'ui-state-disabled': produtorEntity === null || propriedadeEntity === null }"
        role="button"
      />
    </div>
  </form>
</template>

<script>
export default {
  data: () => ({
    produtorEntity: null,
    propriedadeEntity: null,
    produtores: [],
    propriedades: [],
    loadingPropriedades: false,
    searchTimeoutId: null,
    requestSource: null
  }),
  methods: {
    onSearch(search, loading) {
      if (search.length < 3) {
        return;
      }

      clearTimeout(this.searchTimeoutId);
      loading(true);

      this.searchTimeoutId = setTimeout(() => {
        this.requestSource && this.requestSource.cancel();

        const CancelToken = axios.CancelToken;
        this.requestSource = CancelToken.source();

        axios
          .get(`/sidagro/ficha-sanitaria-vegetal/filter-produtor`, {
            cancelToken: this.requestSource.token,
            params: {
              search
            }
          })
          .then(response => response.data)
          .then(response => {
            if (response.status == false) {
              throw response.msg;
            }

            const items = [];
            response.data.produtores &&
              response.data.produtores.forEach(produtor => {
                var indexExists = items.findIndex(
                  x => x.value === produtor.cpf_cnpj
                );
                if (indexExists === -1) {
                  items.push({
                    label: `${produtor.codprodutor} - ${produtor.nomeprodutor}`,
                    value: produtor.cpf_cnpj
                  });
                }
              });

            this.propriedades = [];
            this.produtores = items;

            this.onFocus();

            loading(false);
          })
          .catch(error => {
            console.log(error);
            if (!axios.isCancel(error)) {
              loading(false);
              this.$toast.error(
                "Erro ao tentar recuperar a lista de produtores."
              );
            }
          });
      }, 2000);
    },
    onChangeValue() {
      if (!this.produtorEntity || !this.produtorEntity.value) {
        return;
      }

      this.propriedadeEntity = null;
      this.propriedades = [];
      this.loadingPropriedades = true;
      axios
        .get(`/sidagro/ficha-sanitaria-vegetal/get-propriedades-produtor`, {
          params: {
            cpf_cnpj: this.produtorEntity.value
          }
        })
        .then(response => response.data)
        .then(response => {
          const items = [];
          response.forEach(propriedade => {
            items.push({
              label: propriedade.nomepropriedade,
              value: propriedade.codpropriedade
            });
          });
          this.propriedades = items;
          this.loadingPropriedades = false;
        })
        .catch(error => {
          console.log(error);
          this.$toast.error(
            "Erro ao tentar recuperar a lista de propriedades."
          );
          this.loadingPropriedades = false;
        });
    },
    onFocus() {
      setTimeout(() => {
        const content = document.getElementById("content");
        if (content.scrollHeight > content.clientHeight) {
          content.style.height = content.scrollHeight + 20 + "px";
        }
      }, 100);
    },
    onBlur() {
      const content = document.getElementById("content");
      content.removeAttribute("style");
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ {
  ul {
    li,
    li:hover {
      display: list-item;
      width: auto;
      border: none;
      border-radius: 0;
      padding: 5px 10px;
      box-shadow: none;
    }

    li:hover {
      background-color: #6f7efb;
    }
  }

  button {
    background: transparent !important;
    border: none !important;

    &:active {
      background: transparent !important;
      border: none !important;
    }
  }

  input {
    text-transform: unset;
  }

  .vs__spinner,
  .vs__spinner:after {
    width: 17px;
    height: 17px;
    border-width: 3px;
  }
}
</style>
